var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbstract22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "abstract-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "abstract"
  }, /*#__PURE__*/React.createElement("path", {
    id: "abstract-22_2",
    d: "M16.28 7.99999H9.99996V1.60999C9.97382 1.41328 9.88975 1.2288 9.75845 1.08002C9.62715 0.931235 9.45456 0.824879 9.26263 0.774485C9.0707 0.724091 8.86812 0.731936 8.68067 0.797023C8.49321 0.862109 8.32936 0.981495 8.20996 1.13999L2.84996 10.51C2.76449 10.662 2.72028 10.8338 2.72171 11.0082C2.72314 11.1826 2.77017 11.3536 2.85811 11.5042C2.94606 11.6548 3.07187 11.7798 3.22305 11.8668C3.37424 11.9538 3.54554 11.9997 3.71996 12H9.99996V18.39C10.0261 18.5867 10.1102 18.7712 10.2415 18.92C10.3728 19.0687 10.5454 19.1751 10.7373 19.2255C10.9292 19.2759 11.1318 19.268 11.3192 19.2029C11.5067 19.1379 11.6706 19.0185 11.79 18.86L17.15 9.48999C17.2354 9.33794 17.2796 9.16619 17.2782 8.99178C17.2768 8.81737 17.2298 8.64637 17.1418 8.49575C17.0539 8.34513 16.928 8.22014 16.7769 8.13317C16.6257 8.0462 16.4544 8.00029 16.28 7.99999Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract22);
export default __webpack_public_path__ + "static/media/abstract-22.c503423aff09f8597f4b2210a96aea51.svg";
export { ForwardRef as ReactComponent };